
import React from 'react';

export const CloseIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 3.5L3.5 12.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 12.5L3.5 3.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
